import { useEffect, useRef } from "react";

// Google AdSense slot. The base adsbygoogle.js script (site-ownership
// verification) is loaded once, site-wide, from a <script> tag in
// public/index.html — it's always present, on every page, regardless of
// config. Actual ad UNITS stay fully opt-in via env vars set as Heroku
// config vars — REACT_APP_* vars get baked in at `npm run build` time
// (Heroku's heroku-postbuild), so no ad-unit ID ever needs to live in
// this repo. With no client ID configured this renders nothing: safe in
// local dev and safe until ad units are actually set up.
//
// Placement is deliberately restrained: only on Wordy Whiz's browsing/
// idle screens (dictionary lists, below the Stacks leaderboard), never
// mid-gameplay or mid-flashcard-session, and never on the portfolio
// pages (Home/About/Projects/Contact).
const CLIENT_ID = process.env.REACT_APP_ADSENSE_CLIENT;

/** `slot` is the AdSense ad unit ID for this placement (its own env var per call site). */
function AdSlot({ slot, className = "" }) {
  const insRef = useRef(null);

  useEffect(() => {
    if (!CLIENT_ID || !slot) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // adsbygoogle not ready yet (index.html's script still loading) —
      // nothing to do, it fills the slot itself once it initializes.
    }
  }, [slot]);

  if (!CLIENT_ID || !slot) return null;

  return (
    <div className={`ad-slot ${className}`.trim()}>
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={CLIENT_ID}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}

export default AdSlot;
